import Box from "@mui/material/Box";
import Mui5 from "components/mui5";
import Grid from "components/primitives/Grid";
import Typography from "@mui/material/Typography";
import outputLogoStripes from "assets/images/output-logo-180x180.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import Constants from "config/Constants";

function NoDataFallback() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleAddGroupClick = useCallback(() => {
    navigate(Constants.routes.groupsAdd.route);
  }, [navigate]);

  return (
    <Grid container sx={{ alignItems: "center", justifyContent: "center", height: "100%" }}>
      <Grid>
        <Typography variant="h4" align="center" sx={{ marginBottom: "16px" }}>
          {t("group.all.no_groups_text")}
        </Typography>
        <Mui5.Button color="primary" fullWidth disableElevation variant="contained" onClick={handleAddGroupClick}>
          {t("group.all.add_new_group_button_text")}
        </Mui5.Button>
        <Box sx={{ pt: 3, pb: 16, textAlign: "center" }}>
          <img src={outputLogoStripes} alt={t("global.logo_stripes_alt_text")} />
        </Box>
      </Grid>
    </Grid>
  );
}

export default NoDataFallback;
